import { createStyles, makeStyles, Theme } from '@material-ui/core'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    executions: {
      marginTop: '5%',
      marginLeft: '10%',
      marginRight: '10%',
      marginBottom: '5%',
      display: 'flex',
      justifyContent: 'space-between',
    },
    executionListContainer: {
      minHeight: '600px',
      width: '45%',
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      borderRadius: '8px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    },
    header: {
      textAlign: 'center',
      marginBottom: theme.spacing(1),
      color: theme.palette.text.primary,
      fontWeight: 'bold',
    },
    executionItem: {
      padding: theme.spacing(1),
      borderBottom: `1px solid ${theme.palette.divider}`,
      '&:last-child': {
        borderBottom: 'none',
      },
    },
    executionItemTitle: {
      fontWeight: 'bold',
    },
    executionItemSubtitle: {
      color: theme.palette.text.secondary,
    },
    deleteButton: {
      color: 'gray',
      '&:hover': {
        color: `${theme.palette.primary.main}`,
      },
    },
    downloadLink: {
      color: theme.palette.primary.main,
      textDecoration: 'none',
      fontWeight: 'bold',
      cursor: 'pointer',
      transition: 'color 0.2s ease-in-out',
      '&:hover': {
        color: theme.palette.primary.dark,
        textDecoration: 'underline',
      },
    },
  }),
)
